import lodashOrderBy from 'lodash/orderBy';
import { ProductRow } from './ProductRow';
import { ProductContent } from './ProductRow/ProductContent';
import { Draggable } from '@hello-pangea/dnd';
import { Fragment } from 'react';

export const ProductRows = (props) => {
    const { tag, projectId, opsDisable, checkedItemIds, onItemCheckboxToggle } =
        props;

    const tagItems = lodashOrderBy(
        tag.items.length > 0 ? tag.items : [],
        'sequenceId',
    );

    if (tagItems.length > 0) {
        return (
            <Fragment>
                {tagItems.map((tagItem, index) => (
                    <Draggable
                        draggableId={tagItem.id}
                        index={index}
                        key={tagItem.id}
                    >
                        {(dragProvided) => (
                            <ProductRow
                                tag={tag}
                                tagItem={tagItem}
                                projectId={projectId}
                                opsDisable={opsDisable}
                                provided={dragProvided}
                                onCheckboxToggle={onItemCheckboxToggle}
                                isChecked={checkedItemIds.has(tagItem.id)}
                            />
                        )}
                    </Draggable>
                ))}
            </Fragment>
        );
    }
    return (
        <Fragment>
            <tr>
                <td className="pl-1 pr-1"> </td>
                <td colSpan="6">
                    <ProductContent
                        firstRow="No product to show"
                        secondRow=""
                    />
                </td>
            </tr>
        </Fragment>
    );
};
